import { StyleSheet } from "../../utils";
import { theme } from "../../theme";

export const styles = StyleSheet({
  list: {
    listStyle: "none",
    padding: 0,
    display: "flex",
    margin: `0 -${theme.spacing.xsmall2}`,
  },
  listItem: {
    padding: `0 ${theme.spacing.xsmall2}`,
  },
  listImage: {
    width: theme.spacing.xlarge5,
  },
  modal: {
    width: "auto",
    ":after": { display: "none" },
    maxHeight: "100%",
  },
  modalImage: {
    display: "block",
    maxWidth: "100%",
  },
  buttonGrid: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing.small,
  },
  button: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: theme.colors.light.base,

    ":disabled": {
      color: theme.colors.greyscale.lighter,
      cursor: "not-allowed",
    },
  },
  caption: {
    background: theme.colors.brand.base,
    color: theme.colors.light.base,
    padding: theme.spacing.xsmall,
    textAlign: "left",
  },
});
